export const BlockRuleTypeOptions = [
  {
    label: 'Block All',
    value: 'Block All',
  },
  {
    label: 'Block if...',
    value: 'Block if...',
  },
];

export type TBlockRuleTypeOptions = (typeof BlockRuleTypeOptions)[number]['value'];

export const scaledBlockRuleTagKeyOptions = [
  {
    value: 'targetUrl',
    label: 'targetUrl',
  },
];

export const EVENT_NAME_WITH_BLOCK_RULE = ['conviva_network_request'];

export enum EBlockEventSingleChangeType {
  BLOCK_EVENT_SINGLE_NAME = 'BLOCK_EVENT_SINGLE_NAME',
  BLOCK_EVENT_SINGLE_OPERATOR = 'BLOCK_EVENT_SINGLE_OPERATOR',
  BLOCK_EVENT_SINGLE_VALUE = 'BLOCK_EVENT_SINGLE_VALUE',
}

export enum EBlockEventSingleRuleActionType {
  DELETE_ALL = 'BLOCK_EVENT_SINGLE_DELETE_ALL',
  DELETE_RULE_ITEM = 'BLOCK_EVENT_SINGLE_DELETE_RULE_ITEM',
  ADD_OR_RULE_ITEM = 'BLOCK_EVENT_SINGLE_ADD_OR_RULE_ITEM',
}
